<template>
  <div
    class="dropdown relative border-2 bg-gray-50 hover:border-primary-100 dark:bg-dark-400 dark:border-dark-400"
    style="border-radius: 0.5rem; width: 400px"
    v-on:mouseleave="nested.hide.value = true"
    v-on:mouseover="nested.hide.value = false"
  >
    <button class="px-3 py-2 items-center focus:outline-none text-xl flex" :style="{ width: '400px' }">
      <span :class="'text-base whitespace-nowrap'" :style="{ width: '380px' }">
        {{ itemList[selectedIndex] }}
      </span>
      <svg class="fill-current" style="width: 20px" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
      </svg>
    </button>
    <Transition name="slide-fade">
      <ul
        v-show="!nested.hide.value"
        class="w-full border dark:border-dark-200 dropdown-menu absolute hidden shadow-xl z-10 overflow-y-scroll overflow-x-hidden"
        :class="isLightMode() ? 'custom-scrollbar' : 'custom-scrollbar-dark'"
        style="top: 2.6rem; max-height: 200px"
      >
        <li v-for="(value, index) in itemList" :key="index" class="rounded" :style="{ width: '394px' }">
          <button
            class="py-2 px-3 text-base w-full block whitespace-no-wrap text-left focus:outline-none bg-white hover:bg-primary-50 text-gray-800 dark:bg-dark-200 dark:text-dark-text dark:hover:bg-dark-10 dark:border-dark-200"
            v-on:click="click(index)"
          >
            {{ value }}
          </button>
        </li>
      </ul>
    </Transition>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'

export default defineComponent({
  props: {
    itemList: {
      type: Array,
      required: true
    },
    selectedIndex: {
      type: Number,
      required: true
    },
    selected: {
      type: Function,
      required: true
    }
  },
  setup(props) {
    const { isLightMode } = useConfigStatePresenter()

    const click = (index: number) => {
      const value = props.itemList[index]
      props.selected(index, value)
      hide.value = true
    }

    const hide = ref(true)

    return { click, isLightMode, nested: { hide } }
  }
})
</script>

<style lang="postcss" scoped>
.triangle {
  &::before {
    @apply absolute;
    right: 0.2rem;
    top: 0.6rem;
    border-right: 0.3rem solid transparent;
    border-top: 0.3rem solid;
    border-left: 0.3rem solid transparent;
    content: '';
  }
}

.dropdown:hover .dropdown-menu {
  display: block;
}

.selector-margin-top {
  margin-top: 2px;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 8px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: #ffffff;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.custom-scrollbar-dark::-webkit-scrollbar {
  width: 8px;
}

.custom-scrollbar-dark::-webkit-scrollbar-track {
  background: #4c4c4c;
}

.custom-scrollbar-dark::-webkit-scrollbar-thumb {
  background: #8d8d8d;
  border-radius: 4px;
}

.custom-scrollbar-dark::-webkit-scrollbar-thumb:hover {
  background: #8d9fb9;
}
</style>
